document.addEventListener('DOMContentLoaded', function () {
  const track = document.querySelector('#warum .mtk-track.js-mtk-track');
  const slides = track ? track.querySelectorAll('.mtk-slide') : [];
  const prev = document.querySelector('#warum .js-mtk-prev');
  const next = document.querySelector('#warum .js-mtk-next');

  if (track && slides.length && prev && next) {
    let index = 0;

    function update() {
      const slideWidth = slides[0].getBoundingClientRect().width;
      track.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
    }

    prev.addEventListener('click', () => index > 0 && (--index, update()));
    next.addEventListener('click', () => index < slides.length - 1 && (++index, update()));

    window.addEventListener('resize', update);
    update();
  }

  document.querySelectorAll('.js-mtk-tab').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      document.querySelectorAll('.js-mtk-tab').forEach(b => b.classList.remove('is-active'));
      document.querySelectorAll('.js-mtk-panel').forEach(p =>
        p.classList.toggle('is-active', p.dataset.tab === target)
      );
      btn.classList.add('is-active');
    });
  });

  document.querySelectorAll('.js-mtk-mini-tab').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.mini;
      document.querySelectorAll('.js-mtk-mini-tab').forEach(b => b.classList.remove('is-active'));
      document.querySelectorAll('.js-mtk-mini-panel').forEach(p =>
        p.classList.toggle('is-active', p.dataset.mini === target)
      );
      btn.classList.add('is-active');
    });
  });

  const video = document.querySelector('video[data-auto="1"]');
  if (video && video.muted && video.paused) video.play().catch(() => {});
});
